/*
 * transfer 穿梭框
 * author zhousheng
 */
import * as React from 'react';
import classnames from 'classnames';
import OutlinedClose from 'acud-icon/lib/icons/OutlinedClose';
import OutlinedRight from 'acud-icon/lib/icons/OutlinedRight';
import OutlinedDown from 'acud-icon/lib/icons/OutlinedDown';
import List from '../virtual-list';
import { getBodyHeight, ITEM_HEIGHT } from './util';
const TargetList = (props) => {
    const { filterSource, prefixCls, render, tKeys: targetKeys, setTKeys: setTargetKeys, defaultExpandGroupKey = false, rightStyle = {}, showSearch, virtual = true } = props;
    const listHeight = React.useMemo(() => {
        return getBodyHeight(rightStyle, showSearch === true || showSearch === 'right');
    }, [rightStyle, showSearch]);
    const cancelItem = React.useCallback(data => {
        if (data.disabled) {
            return;
        }
        let curTargetKeys = [...targetKeys];
        if (data.group) {
            const deleteKeys = data.childrenKeys;
            curTargetKeys = curTargetKeys.filter(tKey => !deleteKeys.includes(tKey));
        }
        else if (curTargetKeys.includes(data.key)) {
            curTargetKeys.splice(curTargetKeys.indexOf(data.key), 1);
        }
        setTargetKeys(curTargetKeys);
    }, [targetKeys]);
    const groupKeys = React.useMemo(() => {
        return filterSource.filter(source => source.group).map(source => source.key);
    }, [filterSource]);
    const [expandGroupKey, setExpandGroupKey] = React.useState([]);
    React.useEffect(() => {
        let expandGroupKeys = [];
        if (defaultExpandGroupKey === true) {
            // 默认展开所有折叠项
            expandGroupKeys = groupKeys;
        }
        else if (Array.isArray(defaultExpandGroupKey)) {
            expandGroupKeys = defaultExpandGroupKey;
        }
        else if (typeof defaultExpandGroupKey === 'string' || typeof defaultExpandGroupKey === 'number') {
            expandGroupKeys = [defaultExpandGroupKey];
        }
        setExpandGroupKey(expandGroupKeys);
    }, [defaultExpandGroupKey, groupKeys]);
    const expandGroup = React.useCallback((e, groupKey) => {
        if (expandGroupKey.includes(groupKey)) {
            setExpandGroupKey(keys => {
                keys.splice(keys.indexOf(groupKey), 1);
                return [...keys];
            });
        }
        else {
            setExpandGroupKey(keys => {
                keys.push(groupKey);
                return [...keys];
            });
        }
        e.stopPropagation();
    }, [expandGroupKey]);
    const getTargetItem = React.useCallback((data) => {
        const itemCls = classnames({
            [`${prefixCls}-target-item`]: true,
            [`${prefixCls}-target-item-disabeld`]: data.disabled,
            [`${prefixCls}-target-item-group`]: data.group,
            [`${prefixCls}-target-item-group-option`]: data.groupOption
        });
        return (<div key={data.key} aria-disabled={data.disabled} className={itemCls} style={{
                display: data.groupOption && !expandGroupKey.includes(data.groupKey)
                    ? 'none'
                    : ''
            }}>
                <span className={`${prefixCls}-target-item-wrap`}>
                    {data.group && (<span className={`${prefixCls}-target-item-arrow`} onClick={e => expandGroup(e, data.key)}>
                        {expandGroupKey.includes(data.key)
                    ? <OutlinedDown />
                    : <OutlinedRight />}
                    </span>)}
                    {render
                ? render(data)
                : (<span className={`${prefixCls}-target-item-title`} title={data.title}>{data.title}</span>)}
                </span>
                {!data.disabled && <OutlinedClose className={`${prefixCls}-target-item-cancel`} onClick={() => cancelItem(data)}/>}
            </div>);
    }, [expandGroupKey, targetKeys, render]);
    const virtualData = React.useMemo(() => filterSource.filter(data => !(data.groupOption && !expandGroupKey.includes(data.groupKey))), [filterSource, expandGroupKey]);
    return (<div className={`${prefixCls}-target-list`}>
        {virtual && <List itemKey="key" data={virtualData} height={listHeight} itemHeight={ITEM_HEIGHT}>
            {data => getTargetItem(data)}
        </List>}
        {!virtual && filterSource.map(data => getTargetItem(data))}
    </div>);
};
export default TargetList;
